function isPayRetailers() {
  return window.location.origin === import.meta.env.VITE_PAY_RETAILERS_LOGIN_URL;
}

export { isPayRetailers };
